import React from 'react';
import { motion } from 'framer-motion';
export function Navbar() {
  return <motion.nav className="w-full bg-brand-cream/90 backdrop-blur-md sticky top-0 z-40 border-b border-brand-beige" initial={{
    y: -100
  }} animate={{
    y: 0
  }} transition={{
    duration: 0.5
  }} data-id="element-104">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-20 flex items-center justify-between" data-id="element-105">
        <a href="#" className="flex items-center gap-3" data-id="element-106">
          <img src="https://cdn.magicpatterns.com/uploads/1KoaTgeCpWLvYBxfGMKHPL/logo.jpg" alt="Oser Pro Labs Logo" className="h-12 w-auto rounded-md object-cover" data-id="element-107" />
        </a>
        <div className="hidden md:flex items-center gap-8 text-sm font-medium text-brand-brown" data-id="element-108">
          <a href="#productos" className="hover:text-brand-green transition-colors" data-id="element-109">
            Productos
          </a>
          <a href="#beneficios" className="hover:text-brand-green transition-colors" data-id="element-110">
            Beneficios
          </a>
          <a href="#faq" className="hover:text-brand-green transition-colors" data-id="element-111">
            Preguntas Frecuentes
          </a>
        </div>
        <a href="https://wa.me/56965576936?text=Hola%2C%20quiero%20informaci%C3%B3n%20sobre%20los%20extractos%20de%20hongos" target="_blank" rel="noopener noreferrer" className="hidden md:inline-flex items-center justify-center px-6 py-2.5 bg-brand-green text-white text-sm font-medium rounded-full hover:bg-brand-lightGreen transition-colors" data-id="element-112">
          Consultar ahora
        </a>
      </div>
    </motion.nav>;
}